module.exports = __webpack_public_path__ + "assets/img/Aussie-Broadband-eBook-w540.866cb38b.jpg";